export default __webpack_public_path__ + "static/media/regulamento_pontos.2b77ae42.pdf";